if (!window.__vhCartBubble) {
  window.__vhCartBubble = true;

  const bumpBubble = (bubble) => {
    if (!bubble || bubble.dataset.vhBumping === '1') return;
    bubble.dataset.vhBumping = '1';
    bubble.classList.add('is-bumped');
    const cleanup = () => {
      bubble.classList.remove('is-bumped');
      delete bubble.dataset.vhBumping;
      bubble.removeEventListener('animationend', cleanup);
    };
    bubble.addEventListener('animationend', cleanup);
    setTimeout(cleanup, 700);
  };

  const observeBubble = (bubble) => {
    if (bubble.dataset.vhObserved === '1') return;
    bubble.dataset.vhObserved = '1';
    let lastValue = bubble.textContent.trim();
    const mo = new MutationObserver(() => {
      const current = bubble.textContent.trim();
      if (current && current !== lastValue) bumpBubble(bubble);
      lastValue = current;
    });
    mo.observe(bubble, { childList: true, characterData: true, subtree: true });
  };

  const init = () => {
    document.querySelectorAll('.cart-count-bubble').forEach(observeBubble);
  };

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('vh:cart-updated', init);
}
